var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEidasTrustedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8291 3.78236C30.9218 3.78236 24.5562 10.1159 24.5562 17.9828V26.2038C21.4115 26.3309 18.9176 28.9031 18.9176 32.0802V56.9908C18.9176 60.2497 21.5412 62.8731 24.8 62.8731H53.201C56.4598 62.8731 59.0832 60.2497 59.0832 56.9908V32.0802C59.0832 28.8213 56.4598 26.1977 53.201 26.1977H53.1026V17.9828C53.1015 10.1145 46.7358 3.78125 38.8287 3.78125L38.8291 3.78236ZM38.7264 9.94065H39.0686C43.5452 9.94065 47.1493 13.558 47.1493 18.0513V26.1979H30.6458V18.0513C30.6458 13.558 34.2497 9.94065 38.7265 9.94065H38.7264Z",
    fill: "#2B4375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9861 28.8125L38.3381 30.8067L39.3352 31.1307L38.9861 28.8125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9861 28.8125L39.634 30.8067L38.6369 31.1307L38.9861 28.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9803 30.2612L38.8835 30.2612L38.8835 31.3096L40.9803 30.2612Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9803 30.2612L39.284 31.4937L38.6677 30.6455L40.9803 30.2612Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2186 32.6055L39.5707 30.6113L38.5736 30.9352L40.2186 32.6055Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2186 32.6055L38.5223 31.373L39.1385 30.5248L40.2186 32.6055Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9919 30.2612L39.0888 30.2612L39.0888 31.3096L36.9919 30.2612Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9919 30.2612L38.6883 31.4937L39.3046 30.6455L36.9919 30.2612Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7537 32.6055L38.4016 30.6113L39.3987 30.9352L37.7537 32.6055Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7537 32.6055L39.45 31.373L38.8338 30.5248L37.7537 32.6055Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6079 30.748L30.9599 32.7423L31.9571 33.0662L31.6079 30.748Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6079 30.748L32.2559 32.7422L31.2588 33.0662L31.6079 30.748Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6022 32.1968L31.5053 32.1967L31.5053 33.2452L33.6022 32.1968Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6022 32.1968L31.9058 33.4292L31.2896 32.581L33.6022 32.1968Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8405 34.541L32.1925 32.5468L31.1954 32.8708L32.8405 34.541Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8405 34.541L31.1441 33.3085L31.7603 32.4603L32.8405 34.541Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6138 32.1968L31.7106 32.1967L31.7106 33.2452L29.6138 32.1968Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6138 32.1968L31.3102 33.4292L31.9264 32.581L29.6138 32.1968Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3755 34.541L31.0234 32.5468L32.0205 32.8708L30.3755 34.541Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3755 34.541L32.0719 33.3085L31.4556 32.4603L30.3755 34.541Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.455 36.0215L25.807 38.0157L26.8041 38.3397L26.455 36.0215Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.455 36.0215L27.1029 38.0157L26.1058 38.3397L26.455 36.0215Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4492 37.4702L26.3524 37.4702L26.3524 38.5186L28.4492 37.4702Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4492 37.4702L26.7528 38.7027L26.1366 37.8545L28.4492 37.4702Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6875 39.8145L27.0395 37.8202L26.0424 38.1442L27.6875 39.8145Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6875 39.8145L25.9911 38.582L26.6074 37.7338L27.6875 39.8145Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4608 37.4702L26.5577 37.4702L26.5577 38.5186L24.4608 37.4702Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4608 37.4702L26.1572 38.7027L26.7734 37.8545L24.4608 37.4702Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2225 39.8145L25.8705 37.8202L26.8676 38.1442L25.2225 39.8145Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2225 39.8145L26.9189 38.582L26.3027 37.7338L25.2225 39.8145Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3424 42.4326L24.6944 44.4268L25.6915 44.7508L25.3424 42.4326Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3424 42.4326L25.9904 44.4268L24.9933 44.7508L25.3424 42.4326Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3367 43.8813L25.2398 43.8813L25.2398 44.9297L27.3367 43.8813Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3367 43.8813L25.6403 45.1138L25.0241 44.2656L27.3367 43.8813Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.575 46.2256L25.927 44.2314L24.9299 44.5554L26.575 46.2256Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.575 46.2256L24.8786 44.9931L25.4948 44.1449L26.575 46.2256Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3483 43.8813L25.4451 43.8813L25.4451 44.9297L23.3483 43.8813Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3483 43.8813L25.0447 45.1138L25.6609 44.2656L23.3483 43.8813Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.11 46.2256L24.7579 44.2314L25.755 44.5554L24.11 46.2256Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.11 46.2256L25.8064 44.9931L25.1901 44.1449L24.11 46.2256Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.818 49.3755L26.17 51.3697L27.1671 51.6937L26.818 49.3755Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M26.818 49.3755L27.466 51.3697L26.4689 51.6937L26.818 49.3755Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8123 50.8242L26.7154 50.8242L26.7154 51.8726L28.8123 50.8242Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8123 50.8242L27.1159 52.0567L26.4996 51.2085L28.8123 50.8242Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0505 53.1685L27.4026 51.1742L26.4055 51.4982L28.0505 53.1685Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0505 53.1685L26.3542 51.936L26.9704 51.0878L28.0505 53.1685Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8239 50.8242L26.9207 50.8242L26.9207 51.8726L24.8239 50.8242Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8239 50.8242L26.5202 52.0567L27.1365 51.2085L24.8239 50.8242Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5856 53.1685L26.2335 51.1742L27.2306 51.4982L25.5856 53.1685Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5856 53.1685L27.2819 51.936L26.6657 51.0878L25.5856 53.1685Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5835 54.5527L30.9355 56.5469L31.9326 56.8709L31.5835 54.5527Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5835 54.5527L32.2315 56.5469L31.2344 56.8709L31.5835 54.5527Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5778 56.0015L31.4809 56.0014L31.4809 57.0498L33.5778 56.0015Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5778 56.0015L31.8814 57.2339L31.2651 56.3857L33.5778 56.0015Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.816 58.3457L32.1681 56.3515L31.171 56.6755L32.816 58.3457Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M32.816 58.3457L31.1197 57.1132L31.7359 56.265L32.816 58.3457Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5894 56.0015L31.6862 56.0014L31.6862 57.0498L29.5894 56.0015Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5894 56.0015L31.2857 57.2339L31.902 56.3857L29.5894 56.0015Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3511 58.3457L30.999 56.3515L31.9961 56.6755L30.3511 58.3457Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3511 58.3457L32.0474 57.1132L31.4312 56.265L30.3511 58.3457Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9861 56.2944L38.3381 58.2886L39.3352 58.6126L38.9861 56.2944Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9861 56.2944L39.634 58.2886L38.6369 58.6126L38.9861 56.2944Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9803 57.7432L38.8835 57.7431L38.8835 58.7915L40.9803 57.7432Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9803 57.7432L39.284 58.9756L38.6677 58.1274L40.9803 57.7432Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2186 60.0874L39.5707 58.0932L38.5736 58.4172L40.2186 60.0874Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2186 60.0874L38.5223 58.8549L39.1385 58.0067L40.2186 60.0874Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9919 57.7432L39.0888 57.7431L39.0888 58.7915L36.9919 57.7432Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9919 57.7432L38.6883 58.9756L39.3046 58.1274L36.9919 57.7432Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7537 60.0874L38.4016 58.0932L39.3987 58.4172L37.7537 60.0874Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7537 60.0874L39.45 58.8549L38.8338 58.0067L37.7537 60.0874Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3163 54.1172L45.6683 56.1114L46.6654 56.4354L46.3163 54.1172Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3163 54.1172L46.9642 56.1114L45.9671 56.4354L46.3163 54.1172Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3105 55.5659L46.2137 55.5659L46.2137 56.6143L48.3105 55.5659Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3105 55.5659L46.6142 56.7984L45.9979 55.9502L48.3105 55.5659Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5488 57.9102L46.9009 55.9159L45.9038 56.2399L47.5488 57.9102Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5488 57.9102L45.8525 56.6777L46.4687 55.8295L47.5488 57.9102Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3221 55.5659L46.419 55.5659L46.419 56.6143L44.3221 55.5659Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3221 55.5659L46.0185 56.7984L46.6348 55.9502L44.3221 55.5659Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0839 57.9102L45.7318 55.9159L46.7289 56.2399L45.0839 57.9102Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0839 57.9102L46.7802 56.6777L46.164 55.8295L45.0839 57.9102Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3478 49.4243L50.6998 51.4185L51.6969 51.7425L51.3478 49.4243Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3478 49.4243L51.9957 51.4185L50.9986 51.7425L51.3478 49.4243Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M53.342 50.873L51.2452 50.873L51.2452 51.9214L53.342 50.873Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M53.342 50.873L51.6457 52.1055L51.0294 51.2573L53.342 50.873Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5803 53.2173L51.9324 51.2231L50.9353 51.5471L52.5803 53.2173Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5803 53.2173L50.884 51.9848L51.5002 51.1366L52.5803 53.2173Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3536 50.873L51.4505 50.873L51.4505 51.9214L49.3536 50.873Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3536 50.873L51.05 52.1055L51.6663 51.2573L49.3536 50.873Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1154 53.2173L50.7633 51.2231L51.7604 51.5471L50.1154 53.2173Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1154 53.2173L51.8117 51.9848L51.1955 51.1366L50.1154 53.2173Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6063 42.4326L51.9584 44.4268L52.9555 44.7508L52.6063 42.4326Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6063 42.4326L53.2543 44.4268L52.2572 44.7508L52.6063 42.4326Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6006 43.8813L52.5038 43.8813L52.5037 44.9297L54.6006 43.8813Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6006 43.8813L52.9042 45.1138L52.288 44.2656L54.6006 43.8813Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8389 46.2256L53.1909 44.2314L52.1938 44.5554L53.8389 46.2256Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8389 46.2256L52.1425 44.9931L52.7587 44.1449L53.8389 46.2256Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6122 43.8813L52.709 43.8813L52.709 44.9297L50.6122 43.8813Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6122 43.8813L52.3086 45.1138L52.9248 44.2656L50.6122 43.8813Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3739 46.2256L52.0219 44.2314L53.019 44.5554L51.3739 46.2256Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3739 46.2256L53.0703 44.9931L52.454 44.1449L51.3739 46.2256Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3723 36.0459L50.7244 38.0401L51.7215 38.3641L51.3723 36.0459Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3723 36.0459L52.0203 38.0401L51.0232 38.3641L51.3723 36.0459Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3666 37.4946L51.2697 37.4946L51.2697 38.543L53.3666 37.4946Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3666 37.4946L51.6702 38.7271L51.054 37.8789L53.3666 37.4946Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6049 39.8389L51.9569 37.8447L50.9598 38.1686L52.6049 39.8389Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6049 39.8389L50.9085 38.6064L51.5247 37.7582L52.6049 39.8389Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3782 37.4946L51.475 37.4946L51.475 38.543L49.3782 37.4946Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3782 37.4946L51.0746 38.7271L51.6908 37.8789L49.3782 37.4946Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1399 39.8389L50.7878 37.8447L51.785 38.1686L50.1399 39.8389Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1399 39.8389L51.8363 38.6064L51.22 37.7582L50.1399 39.8389Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3407 30.7959L45.6927 32.7901L46.6898 33.1141L46.3407 30.7959Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3407 30.7959L46.9887 32.7901L45.9916 33.1141L46.3407 30.7959Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M48.335 32.2446L46.2381 32.2446L46.2381 33.293L48.335 32.2446Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M48.335 32.2446L46.6386 33.4771L46.0223 32.6289L48.335 32.2446Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5732 34.5889L46.9253 32.5947L45.9282 32.9186L47.5732 34.5889Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5732 34.5889L45.8769 33.3564L46.4931 32.5082L47.5732 34.5889Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3466 32.2446L46.4434 32.2446L46.4434 33.293L44.3466 32.2446Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3466 32.2446L46.0429 33.4771L46.6592 32.6289L44.3466 32.2446Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1083 34.5889L45.7562 32.5947L46.7533 32.9186L45.1083 34.5889Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1083 34.5889L46.8046 33.3564L46.1884 32.5082L45.1083 34.5889Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0477 41.5854L31.6482 39.0575C33.8019 40.7858 35.9691 42.7172 38.2129 44.9866C43.5116 39.6687 48.9101 34.3582 54.8401 29.8517C55.3478 29.7869 56.5771 31.227 56.5466 31.6509C49.9738 38.1655 44.8162 45.6486 39.9595 53.3375C36.6187 49.2485 32.9575 45.3354 29.0475 41.5848L29.0477 41.5854Z",
    fill: "#F3CA12"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1224 67.4208V73.3531H16.1991V67.4208H14.0479V66.5898H19.3708V67.4208H17.1225H17.1224Z",
    fill: "#333333"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7592 69.2546C22.5684 69.1223 22.3761 69.0561 22.1822 69.0561C21.8713 69.0561 21.599 69.1992 21.3651 69.4854C21.1343 69.7716 21.0188 70.1163 21.0188 70.5195V73.354H20.1417V68.4097H21.0188V69.1991C21.3389 68.6113 21.8144 68.3174 22.4453 68.3174C22.6023 68.3174 22.8285 68.3451 23.124 68.4005L22.7593 69.2545L22.7592 69.2546Z",
    fill: "#333333"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24.578 68.4088V71.5619C24.578 72.3251 24.9089 72.7068 25.5706 72.7068C25.8599 72.7068 26.1246 72.6237 26.3646 72.4575C26.6047 72.2913 26.7632 72.0989 26.8401 71.8804V68.4087H27.7172V73.353H26.8401V72.6697C26.7416 72.8636 26.5431 73.0421 26.2446 73.2052C25.9491 73.3653 25.6598 73.4453 25.3767 73.4453C24.835 73.4453 24.4196 73.2899 24.1303 72.979C23.844 72.6682 23.7009 72.2265 23.7009 71.6541V68.4088H24.578V68.4088Z",
    fill: "#333333"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5945 73.058L28.9038 72.227C29.3932 72.5471 29.7871 72.7071 30.0856 72.7071C30.6273 72.7071 30.8981 72.4794 30.8981 72.0239C30.8981 71.6977 30.6365 71.4176 30.1133 71.1837C29.7102 70.999 29.4378 70.859 29.2962 70.7636C29.1577 70.6682 29.0362 70.5605 28.9315 70.4405C28.83 70.3174 28.753 70.1881 28.7007 70.0527C28.6514 69.9142 28.6268 69.7665 28.6268 69.6095C28.6268 69.2032 28.7746 68.8863 29.07 68.6585C29.3655 68.4308 29.7517 68.3169 30.2287 68.3169C30.5888 68.3169 31.0428 68.4308 31.5906 68.6585L31.3413 69.471C30.9935 69.194 30.6442 69.0555 30.2934 69.0555C30.0841 69.0555 29.9071 69.1048 29.7625 69.2033C29.6209 69.3017 29.5501 69.4264 29.5501 69.5772C29.5501 69.8942 29.7301 70.1342 30.0902 70.2974L30.7181 70.5836C31.1028 70.759 31.3828 70.9591 31.5583 71.1837C31.7337 71.4084 31.8214 71.69 31.8214 72.0285C31.8214 72.4717 31.666 72.8195 31.3551 73.0719C31.0443 73.3212 30.6134 73.4458 30.0625 73.4458C29.5424 73.4458 29.053 73.3165 28.5945 73.058L28.5945 73.058Z",
    fill: "#333333"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M33.054 69.1012H32.4816V68.4087H33.054V67.3746L33.9311 67.0376V68.4087H35.2884V69.1012H33.9311V71.5572C33.9311 71.9727 34.0004 72.2682 34.1389 72.4436C34.2805 72.619 34.5067 72.7067 34.8175 72.7067C35.0422 72.7067 35.2745 72.6498 35.5146 72.5359L35.6438 73.3069C35.2807 73.3992 34.8821 73.4454 34.4482 73.4454C34.0573 73.4454 33.7265 73.3007 33.4556 73.0114C33.1879 72.719 33.054 72.3513 33.054 71.9081V69.1013L33.054 69.1012Z",
    fill: "#333333"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6522 70.9658H37.0883C37.0883 71.5444 37.2468 71.9891 37.5638 72.3C37.8439 72.5708 38.204 72.7062 38.6441 72.7062C39.1457 72.7062 39.5643 72.56 39.8998 72.2676L40.2691 72.9001C40.1337 73.0355 39.9259 73.1525 39.6458 73.251C39.295 73.3802 38.9041 73.4449 38.4733 73.4449C37.8516 73.4449 37.3238 73.234 36.8898 72.8124C36.4066 72.3477 36.165 71.7229 36.165 70.9381C36.165 70.1225 36.4128 69.4685 36.9083 68.9761C37.3515 68.536 37.8762 68.3159 38.4825 68.3159C39.1873 68.3159 39.7397 68.5144 40.1398 68.9114C40.5276 69.2931 40.7215 69.7993 40.7215 70.4303C40.7215 70.6242 40.6984 70.8027 40.6522 70.9658L40.6522 70.9658ZM38.524 69.0546C38.1332 69.0546 37.8054 69.1808 37.5407 69.4331C37.2883 69.6732 37.1452 69.9717 37.1114 70.3287H39.8489C39.8489 69.9748 39.7381 69.6794 39.5166 69.4424C39.2734 69.1839 38.9426 69.0546 38.524 69.0546V69.0546Z",
    fill: "#333333"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7744 73.3486V72.9839C44.4697 73.2885 44.0265 73.4409 43.4448 73.4409C42.8262 73.4409 42.3246 73.2193 41.9399 72.7761C41.5551 72.3329 41.3628 71.742 41.3628 71.0034C41.3628 70.2617 41.5844 69.6292 42.0276 69.106C42.4707 68.5798 42.9986 68.3166 43.611 68.3166C44.1219 68.3166 44.5097 68.4366 44.7744 68.6767V66.3823H45.6515V73.3487H44.7744V73.3486ZM44.7744 69.5538C44.5528 69.2214 44.2496 69.0552 43.8649 69.0552C43.3941 69.0552 43.0124 69.2306 42.72 69.5815C42.4307 69.9323 42.2861 70.3786 42.2861 70.9202C42.2861 72.1113 42.8278 72.7068 43.9111 72.7068C44.0496 72.7068 44.2158 72.6637 44.4097 72.5776C44.6036 72.4883 44.7252 72.3944 44.7744 72.296V69.5537L44.7744 69.5538Z",
    fill: "#333333"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M49.816 73.3534V66.5903H50.7393V72.5226H53.7955V73.3535H49.8161L49.816 73.3534Z",
    fill: "#333333"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4344 66.5391C55.5852 66.5391 55.7129 66.5929 55.8175 66.7006C55.9252 66.8053 55.9791 66.9315 55.9791 67.0792C55.9791 67.23 55.9252 67.3593 55.8175 67.467C55.7129 67.5716 55.5852 67.6239 55.4344 67.6239C55.2866 67.6239 55.1589 67.5716 55.0512 67.467C54.9466 67.3593 54.8942 67.23 54.8942 67.0792C54.8942 66.9284 54.9466 66.8007 55.0512 66.696C55.1558 66.5914 55.2836 66.5391 55.4344 66.5391ZM54.9543 73.353V69.1473H54.2756V68.4087H55.8314V73.353H54.9543Z",
    fill: "#333333"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9022 73.058L57.2115 72.227C57.7009 72.5471 58.0948 72.7071 58.3934 72.7071C58.935 72.7071 59.2059 72.4794 59.2059 72.0239C59.2059 71.6977 58.9443 71.4176 58.4211 71.1837C58.0179 70.999 57.7455 70.859 57.604 70.7636C57.4655 70.6682 57.3439 70.5605 57.2392 70.4405C57.1377 70.3174 57.0607 70.1881 57.0084 70.0527C56.9592 69.9142 56.9346 69.7665 56.9346 69.6095C56.9346 69.2032 57.0823 68.8863 57.3777 68.6585C57.6732 68.4308 58.0594 68.3169 58.5365 68.3169C58.8966 68.3169 59.3505 68.4308 59.8983 68.6585L59.649 69.471C59.3013 69.194 58.952 69.0555 58.6011 69.0555C58.3918 69.0555 58.2148 69.1048 58.0702 69.2033C57.9286 69.3017 57.8578 69.4264 57.8578 69.5772C57.8578 69.8942 58.0379 70.1342 58.398 70.2974L59.0258 70.5836C59.4105 70.759 59.6906 70.9591 59.866 71.1837C60.0414 71.4084 60.1291 71.69 60.1291 72.0285C60.1291 72.4717 59.9737 72.8195 59.6629 73.0719C59.352 73.3212 58.9212 73.4458 58.3703 73.4458C57.8501 73.4458 57.3608 73.3165 56.9022 73.058L56.9022 73.058Z",
    fill: "#333333"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3624 69.1012H60.7899V68.4087H61.3624V67.3746L62.2395 67.0376V68.4087H63.5967V69.1012H62.2395V71.5572C62.2395 71.9727 62.3087 72.2682 62.4472 72.4436C62.5888 72.619 62.815 72.7067 63.1259 72.7067C63.3505 72.7067 63.5829 72.6498 63.8229 72.5359L63.9522 73.3069C63.589 73.3992 63.1905 73.4454 62.7565 73.4454C62.3657 73.4454 62.0348 73.3007 61.764 73.0114C61.4962 72.719 61.3624 72.3513 61.3624 71.9081V69.1013L61.3624 69.1012Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEidasTrustedList);
export default __webpack_public_path__ + "static/media/eidas-trusted-list.9ab6995facb3a512e841ed7ca6fad662.svg";
export { ForwardRef as ReactComponent };